import { Injectable } from '@angular/core';
import { PlugpointEnvironment } from '../PlugpointEnvironment';

@Injectable({ providedIn: 'root' })

export class ConsoleToggleService {
    consoleLog: any = console.log;
    constructor() { }

    disableConsoleInProduction(): void {
        if (PlugpointEnvironment.consoleDisabled) {
            console.warn(`🚨 Console output is disabled on production!`);
            console.log = function (): void { };
            console.debug = function (): void { };
            console.warn = function (): void { };
            console.info = function (): void { };
        }
    }
    enableConsoleInProduction(): void {
        console.log = this.consoleLog;
        setTimeout(() => {
            this.disableConsoleInProduction();
        }, 100);

    }
} 